import React from 'react';
import PropTypes from 'prop-types';
import { Text, Flex } from '@chakra-ui/react';
import { Info } from '../../../images';

const InfoText = ({ text, ...rest }) => {
  return (
    <Flex alignItems="center" {...rest}>
      <Info />
      <Text ml={2}>{text}</Text>
    </Flex>
  );
};

InfoText.propTypes = {
  text: PropTypes.string.isRequired,
};

export default InfoText;
